import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { cloneDeep, debounce } from 'lodash';
import setRules from '@/libs/rules';

var codeImg = require('@/assets/image/code.png');

var countImg = require('@/assets/image/count.png');

var pwdImg = require('@/assets/image/pwd.png');

var rule = [{
  key: 'account',
  name: '账号'
}, {
  key: 'password',
  name: '密码'
}, {
  key: 'code',
  name: '验证码'
}];
var initForm = {
  account: '',
  password: '',
  code: ''
};
export default {
  data: function data() {
    return {
      codeImg: codeImg,
      countImg: countImg,
      pwdImg: pwdImg,
      // 快速选择用户
      dialogVisible: false,
      // 表单
      formLogin: cloneDeep(initForm),
      codeCheck: '',
      // 表单校验
      rules: setRules(rule)
    };
  },
  created: function created() {
    YL.cookies.set('loginForm', {});
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['login'])), {}, {
    getCode: function getCode(val) {
      this.codeCheck = val;
    },

    /**
     * @description 提交表单
     */
    submit: debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this = this;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs.loginForm.validate(function (valid) {
                if (!valid) return _this.$message.error('表单校验失败，请检查');

                if (_this.formLogin.code.toLowerCase() !== _this.codeCheck) {
                  _this.$refs.code.createdCode();

                  _this.formLogin.code = '';
                  return YL.message('验证码错误', 'error');
                }

                var pswMD5 = YL.md5(_this.formLogin.password);

                _this.login({
                  account: _this.formLogin.account,
                  password: pswMD5
                }).then( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                    var _yield$_this$$api$che, storeStatus;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.$api.checkTokenStatus();

                          case 2:
                            _yield$_this$$api$che = _context.sent;
                            storeStatus = _yield$_this$$api$che.storeStatus;

                            if (!(storeStatus == 6)) {
                              _context.next = 7;
                              break;
                            }

                            _context.next = 7;
                            return _this.getUserSig();

                          case 7:
                            YL.isStoreAuto(storeStatus);

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    })), 500, {
      leading: true,
      trailing: false
    })
  })
};